interface MenuItemListFormDataParams {
  page?: number | string;
  itemPerPage?: number | string;
  search?: Record<string, unknown>;
  globalSearch?: string;
  filterCategoryId?: string;
  filterSubCategoryId?: string;
  includePagination?: boolean;
}

export const buildMenuItemListFormData = ({
  page,
  itemPerPage,
  search = {},
  globalSearch = "",
  filterCategoryId = "",
  filterSubCategoryId = "",
  includePagination = true,
}: MenuItemListFormDataParams): FormData => {
  const formData = new FormData();

  if (includePagination) {
    formData.append("page", String(page));
    formData.append("per_page", String(itemPerPage));
  }

  if (Object.keys(search).length) {
    formData.append("search", JSON.stringify(search));
  }

  formData.append("global_search", globalSearch);

  if (filterCategoryId) {
    formData.append("category_id", filterCategoryId);
  }

  if (filterSubCategoryId) {
    formData.append("sub_category_id", filterSubCategoryId);
  }

  return formData;
};
